import { IMDSToggleButtonProps } from "./toggle-button.types";
import { StyledToggleButton } from "./toggle-button.style";
import { MDSToggleButtonClearToggleButton } from "./clear-toggle-button";
import { MDSButtonSlotName } from "@/mds/components/buttons/button";
import { MDSIcon, MDSIconKind } from "@/mds/components/icon";
import { forwardRef, Ref } from "react";

export const MDSToggleButton = forwardRef(
  (
    {
      isToggled = false,
      label,
      isOpen,
      setIsOpen,
      onClear,
      iconKind,
      ...props
    }: IMDSToggleButtonProps,
    ref: Ref<HTMLButtonElement>
  ) => {
    return (
      <StyledToggleButton
        ref={ref}
        $isToggled={isToggled}
        onClick={() => setIsOpen?.(true)}
        data-mds-name="toggle-button"
        {...props}
      >
        {iconKind && <MDSIcon slot={MDSButtonSlotName.LeftIcon} kind={iconKind} />}
        {label}
        <div slot={MDSButtonSlotName.RightIcon}>
          {isToggled && !!onClear ? (
            <MDSToggleButtonClearToggleButton onSelectClear={onClear} />
          ) : isOpen ? (
            <MDSIcon kind={MDSIconKind.AngleUp} />
          ) : (
            <MDSIcon kind={MDSIconKind.AngleDown} />
          )}
        </div>
      </StyledToggleButton>
    );
  }
);

MDSToggleButton.displayName = "MDSToggleButton";
